<template>
  <button
    :class="classes"
    :disabled="disabled"
    v-bind="$attrs"
  >
    <component v-if="icon" :is="icon" :size="size === 'sm' ? 14 : 16" />
    <slot />
  </button>
</template>

<script>
export default {
  name: 'AppButton',
  inheritAttrs: false,
  props: {
    variant: { type: String, default: 'secondary' },
    size: { type: String, default: 'md' },
    icon: { type: [Object, Function], default: null },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    classes() {
      return [
        'btn',
        `btn-${this.variant}`,
        this.size === 'sm' ? 'btn-sm' : this.size === 'lg' ? 'btn-lg' : ''
      ].filter(Boolean)
    }
  }
}
</script>
